module.exports = __webpack_public_path__ + "img/icon_quotation_mark.a342d97c.svg";